import { render, staticRenderFns } from "./Editor-Login.vue?vue&type=template&id=4f6ef563"
import script from "./Editor-Login.vue?vue&type=script&lang=ts"
export * from "./Editor-Login.vue?vue&type=script&lang=ts"
import style0 from "./Editor-Login.vue?vue&type=style&index=0&id=4f6ef563&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports